<template>
  <page-header>
    <template v-slot:title> Apparaat opdracht </template>
  </page-header>
  <div class="pump-assignment-card -mt-32">
    <div class="mx-auto w-10/12 pb-12">
      <div class="rounded-lg py-6">
        <div class="pumpMaintenanceRow grid grid-col-12 pb-8">
          <card>
            <template v-slot>
              <div class="pt-4 pb-6">
                <label for="txtSearchPump" class="block leading-6 text-black font-bold text-base">Zoek apparaat</label>
                <div class="grid grid-cols-2 my-2">
                  <div class="col-span-2">
                    <div class="flex">
                      <input
                        type="text"
                        name="txtSearchPump"
                        id="txtSearchPump"
                        class="w-60 h-10 px-4 rounded border border-gray-400 py-1.5 text-black placeholder:text-gray-400 sm:text-base sm:leading-6"
                        placeholder="Soort apparaat of serienummer"
                      />
                      <button
                        type="button"
                        @click="searchPump()"
                        class="inline-flex items-center gap-x-2 ml-3.5 rounded-md bg-pdsPrimaryColor w-32 h-10 p-3 pl-6 text-base font-bold text-white border-0"
                      >
                        Zoeken <v-search-icon class="-mr-0.5 w-6 h-6" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <span class="text-2xl font-semibold leading-6 flex-1 mx-2">
                {{ isOwnPumps ? 'Apparaten uit eigen depot' : 'Apparaten uit Mediq depot' }}
              </span>
              <!-- Available Pumps -->
              <div
                v-if="
                  isOwnPumps == true && computedAvailablePumps.pumpList && computedAvailablePumps.pumpList.length > 0
                "
              >
                <div class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden">
                  <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                    <li
                      v-for="(row, index) in computedAvailablePumps.pumpList"
                      :key="index"
                      class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                      @click.prevent="selectPump(index, row)"
                    >
                      <div class="flex w-3/5 gap-x-8 ml-10">
                        <span class="mt-2.5">
                          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="row.imageURL" alt="" />
                        </span>
                        <div class="w-80 flex-auto ml-4">
                          <p class="mb-1 text-base font-semibold leading-6 text-gray-900">{{ row.pumpDesc }}</p>
                          <span class="block text-sm truncate text-xs leading-5 text-gray-500">
                            <span>{{ getStatusField(row.equipmentStatus, row.lendoutWarehouseId) }}</span> &nbsp;&nbsp;
                            {{ row.serialNo }} &nbsp;&nbsp;
                            <span v-if="row.daysLeftForMaintenance == null">Onbekend</span>
                            <span v-else>{{ 'Onderhoud in ' + row.daysLeftForMaintenance + ' dagen' }}</span>
                          </span>
                          <span
                            v-if="row.equipmentStatus == 'OutOfDepot'"
                            class="block mt-1 text-sm truncate text-xs leading-5 text-gray-500"
                          >
                            {{ row.pumpUseReason }}
                          </span>
                        </div>
                      </div>
                      <div class="pt-2 mr-10">
                        <button
                          type="button"
                          :class="{ 'bg-pdsPrimaryColor': isSelected[index], 'bg-white': !isSelected[index] }"
                          class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                        >
                          <span :class="{ 'text-white': isSelected[index] }" class="text-pdsPrimaryColor">{{
                            isSelected[index] ? 'Apparaat gekozen' : 'Kies dit apparaat'
                          }}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Mediq Depot Pumps -->
              <div v-else-if="isOwnPumps == false && additionalPumps && additionalPumps.length > 0">
                <div class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden">
                  <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                    <li
                      v-for="(row, index) in additionalPumps"
                      :key="index"
                      class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                      @click.prevent="selectPump(index, row)"
                    >
                      <div class="flex w-3/5 gap-x-8 ml-10">
                        <span class="mt-2.5">
                          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="row.imageURL" alt="" />
                        </span>
                        <div class="w-80 flex-auto ml-4">
                          <p class="mb-1 text-base font-semibold leading-6 text-gray-900">{{ row.pumpDesc }}</p>
                          <span class="text-sm truncate text-xs leading-5 text-gray-500">
                            <!-- {{getStatusField(row.equipmentStatus,row.lendoutWarehouseId) }} &nbsp;&nbsp; -->
                            <span v-if="row.daysLeftForMaintenance == null">Onbekend</span>
                            <span v-else>{{ 'Onderhoud in ' + row.daysLeftForMaintenance + ' dagen' }}</span>
                          </span>
                        </div>
                      </div>
                      <div class="pt-2 mr-10">
                        <button
                          type="button"
                          :class="{ 'bg-pdsPrimaryColor': isSelected[index], 'bg-white': !isSelected[index] }"
                          class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                        >
                          <span :class="{ 'text-white': isSelected[index] }" class="text-pdsPrimaryColor">{{
                            isSelected[index] ? 'Apparaat gekozen' : 'Kies dit apparaat'
                          }}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- No Pumps Warning! -->
              <div v-else-if="patientPumpConfiguration" class="pump-assignment__no-pumps">
                <v-table>
                  <thead>
                    <!-- <tr class="pump-assignment__no-pumps__cell_thead">
                      <th />
                    </tr> -->
                  </thead>
                  <tr>
                    <td class="pump-assignment__no-pumps__cell_data">
                      <v-warning-message
                        :warning="'Helaas zijn er op dit moment geen apparaten beschikbaar in uw depot'"
                        :message="'Selecteer hieronder de optie om een apparaat vanuit het Mediq depot te bestellen'"
                        :html="false"
                        :is-urgent="false"
                      />
                    </td>
                  </tr>
                </v-table>
              </div>

              <div class="mb-5 mr-20">
                <a
                  class="text-black font-normal text-lg underline cursor-pointer flex justify-end"
                  @click="getAdditionalPumps(isOwnPumps)"
                >
                  {{ isOwnPumps ? 'Apparaat uit Mediq depot selecteren' : 'Apparaat uit eigen depot selecteren' }}
                </a>
              </div>

              <!-- Starting packages -->
              <div ref="startingPackagesRef">
                <div class="pt-2.5" v-if="relationProductId !== 0">
                  <span class="text-2xl font-semibold leading-6 flex-1 mx-2">
                    {{
                      isConsignmentStartingPackages
                        ? 'Startpakketten uit eigen depot'
                        : 'Startpakketten uit Mediq depot'
                    }}
                  </span>
                  <div
                    class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden"
                    v-if="startingPackages && startingPackages.length > 0"
                  >
                    <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                      <li class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer">
                        <div class="flex w-3/5 gap-x-8 ml-10">
                          <span class="mt-2.5">
                            <img
                              class="h-12 w-12 flex-none rounded-full bg-gray-50"
                              src="@/static/img/no-startingpackage-image.png"
                              alt=""
                            />
                          </span>
                          <div class="w-80 flex-auto ml-4">
                            <p class="mb-1 text-base font-semibold leading-6 text-gray-900">
                              Ik wil geen startpakket aanvragen bij deze apparaat
                            </p>
                          </div>
                        </div>
                        <div class="pt-2 mr-10">
                          <button
                            type="button"
                            @click="setNoStartingPackage"
                            class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                            :class="isNoStartingPackageOptionSelected ? 'bg-pdsPrimaryColor' : 'bg-white'"
                          >
                            <span :class="!isNoStartingPackageOptionSelected ? 'text-pdsPrimaryColor' : 'text-white'">
                              Geen startpakket inzetten
                            </span>
                          </button>
                        </div>
                      </li>
                      <li
                        v-for="(row, index) in startingPackages"
                        :key="index"
                        class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                        @click="selectProduct(index, row)"
                      >
                        <div class="flex w-3/5 gap-x-8 ml-10">
                          <span class="mt-2.5">
                            <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="row.imageURL" alt="" />
                          </span>
                          <div class="w-80 flex-auto ml-4">
                            <p class="mb-1 text-base font-semibold leading-6 text-gray-900">{{ row.pumpDesc }}</p>
                            <span class="text-sm truncate text-xs leading-5 text-gray-500">
                              {{ row.productCode }}
                            </span>
                          </div>
                        </div>
                        <div class="pt-2 mr-10">
                          <button
                            type="button"
                            :class="{
                              'bg-pdsPrimaryColor': isPackageSelected[index],
                              'bg-white': !isPackageSelected[index]
                            }"
                            class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                          >
                            <span
                              :class="{
                                'text-white': isPackageSelected[index],
                                'text-pdsPrimaryColor': !isPackageSelected[index]
                              }"
                              class="text-pdsPrimaryColor"
                            >
                              {{ isPackageSelected[index] ? 'Pakket gekozen' : 'Kies dit pakket' }}
                            </span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden"
                    v-else-if="relationProductId !== 0 && allowNoStartingPackageSelection"
                  >
                    <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                      <li class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer">
                        <div class="flex w-3/5 gap-x-8 ml-10">
                          <span class="mt-2.5">
                            <img
                              class="h-12 w-12 flex-none rounded-full bg-gray-50"
                              src="@/static/img/no-startingpackage-image.png"
                              alt=""
                            />
                          </span>
                          <div class="w-80 flex-auto ml-4">
                            <p class="mb-1 text-base font-semibold leading-6 text-gray-900">
                              Ik wil geen startpakket aanvragen bij deze apparaat
                            </p>
                          </div>
                        </div>
                        <div class="pt-2 mr-10">
                          <button
                            type="button"
                            @click="setNoStartingPackage"
                            class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                            :class="isNoStartingPackageOptionSelected ? 'bg-pdsPrimaryColor' : 'bg-white'"
                          >
                            <span :class="!isNoStartingPackageOptionSelected ? 'text-pdsPrimaryColor' : 'text-white'">
                              Geen startpakket inzetten
                            </span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div v-else-if="relationProductId !== 0">
                    <v-warning-message
                      class="mt-3 ml-12 w-1/2"
                      :warning="'Helaas heeft u volgens onze administratie geen startpakketten op vooraad in uw depot'"
                      :message="'Selecteer hieronder de optie om een startpakket vanuit het Mediq depot te bestellen'"
                      :html="false"
                      :is-urgent="false"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-5 mr-20" v-if="relationProductId !== 0">
                <a
                  class="text-black font-normal text-lg underline cursor-pointer flex justify-end"
                  @click="getAdditionalStartingPackages(!isConsignmentStartingPackages)"
                >
                  {{
                    isConsignmentStartingPackages
                      ? 'Startpakket uit Mediq depot selecteren'
                      : 'Startpakket uit eigen depot selecteren'
                  }}
                </a>
              </div>

              <!-- Starting packages Question -->
              <div class="pt-4 pb-6 font-normal text-base text-black" v-if="showDeliveryDetails">
                <legend class="font-semibold leading-6 pb-4">Wanneer moet Mediq het apparaat leveren? *</legend>
                <div class="flex items-center pb-2">
                  <input
                    id="TodayWithinFourHours"
                    name="deliveryOptions"
                    type="radio"
                    @change="deliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="TodayWithinFourHours" class="ml-3 block font-normal leading-6">
                    Vandaag (binnen 4 uur)
                  </label>
                </div>
                <div class="flex items-center pb-2">
                  <input
                    id="TomorrowBeforeTwelve"
                    name="deliveryOptions"
                    type="radio"
                    @change="deliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="TomorrowBeforeTwelve" class="ml-3 block font-normal leading-6">
                    Morgen (vóór 12:00 uur)
                  </label>
                </div>
                <div class="flex items-center pb-2">
                  <input
                    id="Other"
                    name="deliveryOptions"
                    type="radio"
                    @change="deliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="Other" class="ml-3 block font-normal leading-6">Anders, namelijk:</label>
                </div>
                <div v-if="showDeliveryDate" class="font-normal text-base text-black">
                  <legend class="font-semibold leading-6 pb-2">Datum</legend>
                  <div>
                    <v-input-date-picker
                      class="w-1/5"
                      ref="deliveryDate"
                      type="date"
                      name="deliveryDate"
                      label=""
                      autofocus
                      custom-date-range
                      @selected="handleDeliveryDate"
                    />
                  </div>
                </div>
                <div v-if="showLeveringError">
                    <span class="inline-flex items-center text-red-500 text-xs mt-1">
                        <ExclamationCircleIcon
                          class="size-5 mr-1 shrink-0 pointer-events-none"
                          aria-hidden="true"
                        />
                        Dit veld is verplicht.
                    </span>
                </div>
                <div class="w-11/12 flex pt-6 pb-4">
                  <div class="w-2/5">
                    <legend class="font-semibold leading-6 pb-4">Gewenste afleverlocatie</legend>
                    <div class="flex items-center pb-2">
                      <input
                        id="homeAddress"
                        name="deliveryLocation"
                        type="radio"
                        checked
                        @change="deliveryLocationSelect"
                        class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                      />
                      <label for="homeAddress" class="ml-3 block font-normal leading-6">Woonadres</label>
                    </div>
                    <div v-if="deliveryAddress && deliveryAddress.AdresId !== 0" class="flex items-center pb-2">
                      <input
                        id="deliveryAddress"
                        name="deliveryLocation"
                        type="radio"
                        @change="deliveryLocationSelect"
                        class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                      />
                      <label for="deliveryAddress" class="ml-3 block font-normal leading-6">
                        Afwijkend afleveradres
                      </label>
                    </div>
                    <div class="flex items-center pb-2">
                      <input
                        id="differentAddress"
                        name="deliveryLocation"
                        type="radio"
                        @change="deliveryLocationSelect"
                        class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                      />
                      <label for="differentAddress" class="ml-3 block font-normal leading-6">
                        Eenmalig afwijkend afleveradres
                      </label>
                    </div>
                  </div>
                  <div class="w-2/5">
                    <legend class="font-semibold leading-6 pb-4">Afleveradres</legend>
                    <div v-if="showHomeAddress" class="flex items-center pb-2 block text-sm font-normal leading-6">
                      {{ homeAddress.Straatnaam }} {{ homeAddress.Huisnummer }} {{ homeAddress.Toevoeging }} <br />
                      {{ homeAddress.Postcode }} {{ homeAddress.Woonplaats }}<br />
                      {{ homeAddress.Land }}
                    </div>
                    <div v-if="showDeliveryAddress && deliveryAddress && deliveryAddress.AdresId !== 0">
                      {{ deliveryAddress.Straatnaam }} {{ deliveryAddress.Huisnummer }}
                      {{ deliveryAddress.Toevoeging }} <br />
                      <span class="mb-1">{{ deliveryAddress.Postcode }} {{ deliveryAddress.Woonplaats }}</span> <br />
                      <span>{{ deliveryAddress.Land }}</span>
                    </div>

                    <div class="grid grid-rows-1 my-2 w-3/4" v-if="showAddressDetails">
                      <div class="grid grid-cols-2 gap-2">
                        <div class="flex items-center px-2 py-2 col">
                          <div class="col w-full">
                            <v-input-group-simple-2
                              id="Postcode"
                              v-model="differentAddress.Postcode"
                              type="text"
                              maxlength="7"
                              :rules="{
                                required: true,
                                regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                              }"
                              label="Postcode"
                              @blur="autoFillAddress()"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col">
                          <div class="col w-full">
                            <v-input-group-simple-2
                              id="Huisnummer"
                              v-model="differentAddress.Huisnummer"
                              type="text"
                              :rules="{
                                required: true
                              }"
                              label="Huisnummer"
                              @blur="autoFillAddress()"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col-span-2">
                          <div class="w-full">
                            <v-input-group-simple-2
                              id="Toevoeging"
                              v-model="differentAddress.Toevoeging"
                              type="text"
                              :rules="{
                                required: false
                              }"
                              label="Toevoeging"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col-span-2">
                          <div class="w-full">
                            <v-input-group-simple-2
                              id="Straatnaam"
                              :key="prefillAddressDataKey"
                              v-model:value="differentAddress.Straatnaam"
                              type="text"
                              :rules="{
                                required: true
                              }"
                              label="Straatnaam"
                              :disabled="addressLookupSuccessful"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col-span-2">
                          <div class="w-full">
                            <v-input-group-simple-2
                              id="Woonplaats"
                              :key="prefillAddressDataKey"
                              v-model:value="differentAddress.Woonplaats"
                              type="text"
                              :rules="{
                                required: true
                              }"
                              label="Plaats"
                              :disabled="addressLookupSuccessful"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex items-center pb-4">
                  <v-input-group-simple-2
                    id="TelephoneNumber"
                    ref="manualTelephoneNumberRef"
                    v-model="manualTelephoneNumber"
                    :rules="{
                      required: true,
                      regex: /^0\d{9}$/
                    }"
                    type="text"
                    label="Telefoonnummer"
                  />
                </div>

                <div class="flex items-center pb-4 w-6/12">
                  <v-textarea-group
                    v-model="optionalText"
                    inputid="Uw bericht"
                    label="Opmerkingen (optioneel)"
                    @input="setRemark"
                  />
                </div>
              </div>

              <div class="row justify-content-end pt-4">
                <v-button md primary :class="getButtonStatus()" @click.prevent="savePump"> Toewijzen </v-button>
                <v-button md hollow transparent @click.prevent="cancelPumpAssignment"> Annuleren </v-button>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>

  <generic-modal v-if="reConfirmationPopup">
    <template #body>
      <p>
        U staat op het punt om te stoppen met het toewijzen van een apparaat aan uw patiënt. Indien u op annuleren klikt
        wordt er geen apparaat geleverd en komt er een actie voor apparaat toewijzen op uw actielijst. Kies apparaat
        toewijzen als u toch een apparaat wenst toe te wijzen.
      </p>
    </template>
    <template #footer>
      <v-button md hollow transparent @click.prevent="prescriberRredirect('/patientdashboard')"> Annuleren </v-button>
      <v-button tagelement="button" md primary @click.prevent="cancelReConfirmationPopup">
        Apparaat toewijzen
      </v-button>
    </template>
  </generic-modal>

  <generic-modal v-if="showPopup">
    <template #header> Apparaat toegevoegd </template>
    <template #body>
      <p>
        Het geselecteerde apparaat is succesvol toegevoegd aan de machtiging. Wilt u nog een apparaat aanvragen? Voor elk apparaat moet een aparte machtiging worden aangemaakt. Klik dan op 'Nieuwe machtiging toevoegen'.
      </p>
    </template>
    <template #footer>
      <v-button v-if="getAccountabilityFlowStatus()" md hollow transparent @click.prevent="createAccountability()">
        Nieuwe machtiging toevoegen
      </v-button>
      <v-button
        v-else
        md
        hollow
        transparent
        class="pump-assignment__more-pumps__cancel-pumpassignment"
        @click.prevent="prescriberRredirect('/')"
      >
        Naar mijn dashboard
      </v-button>
      <v-button md primary @click.prevent="prescriberRredirect('/patientdashboard')"> Naar patiënt dashboard </v-button>
    </template>
  </generic-modal>
</template>

<script>
import moment from 'moment';
import { useRouter } from 'vue-router';
import VTable from '@/components/shared/table/Table';
import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker';
import { useStore, mapActions } from 'vuex';
import { computed, ref, getCurrentInstance } from 'vue';
import GenericModal from '@/components/shared/GenericModal';
import VWarningMessage from '@/components/shared/WarningMessage';
import { router$ } from '@/router/router$';
import { useForm } from 'vee-validate';
import { from, of, combineLatest } from 'rxjs';
import { map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { getLicenseOverview, activeCustomerId$, activePpwRecId$, navigateToAccountability } from '@/services';
import VSearchIcon from 'icons/Magnify';
import { watch } from 'vue';
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'PumpAssignment',
  components: {
    VTable,
    GenericModal,
    VWarningMessage,
    VInputDatePicker,
    VSearchIcon,
    ExclamationCircleIcon
  },
  setup() {
    const { validate } = useForm();
    const router = useRouter();
    const store = useStore();
    const licenseId = ref(null);
    const accountabilityId = ref(null);
    const licenseOverview = ref(null);
    const customerId = ref(null);
    const patientPumpConfiguration = ref(null);
    const availablePumps = ref([]);
    const userWarehouseId = ref(null);
    const computedAvailablePumps = ref([]);
    const isNoStartingPackageOptionSelected = ref(false);
    const isPackageSelected = ref([]);
    const startingPackages = ref([]);
    const isConsignmentStartingPackages = ref(true);
    const relationProductId = ref(0);
    const selectedDeliveryOption = ref('');
    const selectedPackageProductIds = ref([]);
    const showDeliveryDetails = ref(false);
    const isOwnPumps = ref(true);
    const isSelected = ref([]);
    const pumpId = ref('');
    const productId = ref('');
    const serialNumber = ref('');
    const mediqPumpOptionSelected = ref(false);
    const isPumpSelected = ref(false);
    const selectedOption = ref('');
    const selectedDeliveryLocation = ref('homeAddress');
    const showPopup = ref(false);
    const additionalPumps = ref([]);
    const manualTelephoneNumber = ref('');
    const showManualPump_Warning = ref(false);
    const showHomeAddress = ref(true);
    const showDeliveryAddress = ref(false);
    const showAddressDetails = ref(false);
    const showDeliveryDate = ref(false);
    const deliveryDate = ref(null);
    const optionalText = ref('');
    const reConfirmationPopup = ref(false);
    const validationStatus = ref(false);
    const showLeveringError = ref(false);
    const addressLookup = ref(null);
    const startingPackagesRef = ref(null);
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const prefillAddressDataKey = ref(0);
    const allowNoStartingPackageSelection = ref(false);
    const pumpsHeadersForSorting = ref({
      Omschrijving: 'pumpDesc',
      Serienummer: 'serialNo',
      'Onderhoud nodig in': 'daysLeftForMaintenance'
    });

    const patientGegevens = computed(() => store.getters['patient/getPatientGegevens']);
    const user = computed(() => store.getters['navigation/getUser']);
    const homeAddress = computed(() => store.getters['patient/getPatientHomeAddress']);
    const differentAddress = computed(() => store.getters['patient/getPatientDifferentAddress']);
    const deliveryAddress = computed(() => store.getters['patient/getPatientDeliveryAddress']);
    const depotMaterialIds = computed(() => store.getters['navigation/getCTypeInStockMaterialIds']);

    const deliveryDetailsValidated = computed(() => {
      return showDeliveryDetails.value == true && selectedDeliveryLocation.value !== '';
    });

    const serialNumberValidated = computed(() => {
      if (selectedOption.value === 'manualpump' && serialNumber.value === '') {
        return false;
      }
      return true;
    });

    const licenseOverviews = computed(() => {
      if (!licenseOverview.value) {
        return [];
      }

      return [licenseOverview.value];
    });

    const addressLookupSuccessful = computed(() => {
      return addressLookup.value !== null;
    });

    const saveAllocatePump = (value) => store.dispatch('patient/saveAllocatePump', value);
    const allocatePumpFromMediqDepot = (value) => store.dispatch('patient/allocatePumpFromMediqDepot', value);
    const getAdditionalPumpsStore = (value) => store.dispatch('patient/getAdditionalPumps', value);
    const setShowExtendLicensesBlock = (value) => store.commit('accountability/setShowExtendLicensesBlock', value);
    const fetchAddressLookup = (value) => store.dispatch('patient/fetchAddressLookup', value);
    const getStartingPackagesStore = (value) => store.dispatch('patient/getStartingPackages', value);

    const licenseId$ = router$.pipe(map((route) => route && route.params.licenseId / 1));

    const customerId$ = activeCustomerId$;

    const licenseOverview$ = combineLatest([customerId$, activePpwRecId$, licenseId$]).pipe(
      switchMap(([customerId, ppwRecId, licenseId]) => {
        return licenseId && ppwRecId && customerId
          ? from(getLicenseOverview(customerId, ppwRecId, licenseId))
          : of(null);
      }),
      publishReplay(1),
      refCount()
    );

    const accountabilityId$ = licenseOverview$.pipe(map((license) => (license ? license.accountabilityId : null)));

    licenseId$.subscribe((id) => {
      licenseId.value = id;
    });

    accountabilityId$.subscribe((id) => {
      accountabilityId.value = id;
    });

    licenseOverview$.subscribe((overview) => {
      licenseOverview.value = overview;
    });

    customerId$.subscribe((id) => {
      customerId.value = id;
    });

    store.dispatch('patient/fetchPatientAddress', customerId.value);
    store.dispatch('patient/fetchPatientPumpConfiguration').then((response) => {
      patientPumpConfiguration.value = response.data;
    });
    let requiredIds = {
      Status: 1
    };

    const computeAvailablePumps = () => {
      computedAvailablePumps.value = Object.assign([], availablePumps.value);
      computedAvailablePumps.value.pumpList = computedAvailablePumps.value.pumpList.sort((a, b) =>
        a.pumpDesc.localeCompare(b.pumpDesc)
      );
    };

    store.dispatch('patient/fetchAvailablePumps', requiredIds).then((response) => {
      availablePumps.value = response.data;
      computeAvailablePumps();
      userWarehouseId.value = response.data.userWarehouseId;
    });

    const setNoStartingPackage = () => {
      isNoStartingPackageOptionSelected.value = true;
      isPackageSelected.value = [];
    };

    const getAdditionalStartingPackages = (consignmentProductFlag) => {
      isPackageSelected.value = [];
      startingPackages.value = [];
      isNoStartingPackageOptionSelected.value = false;
      selectedDeliveryOption.value = '';
      selectedPackageProductIds.value = [];

      let startingPackagesInput = {
        ProductId: relationProductId.value,
        DepotMaterialIds: depotMaterialIds.value?.join(',') ?? '',
        ConsignmentProductFlag: consignmentProductFlag
      };
      getStartingPackagesStore(startingPackagesInput).then((response) => {
        allowNoStartingPackageSelection.value = false;
        startingPackages.value = response.data;
        if (startingPackages.value.length > 0) {
          showDeliveryDetails.value = false;
        } else {
          if (isOwnPumps.value === false) {
            showDeliveryDetails.value = true;
          }
          if (!consignmentProductFlag) {
            allowNoStartingPackageSelection.value = true;
          }
        }
      });

      isConsignmentStartingPackages.value = consignmentProductFlag;
    };

    const selectPump = async (index, data) => {
      for (var i = 0; i < isSelected.value.length; i++) {
        isSelected.value[i] = false;
      }
      isSelected.value[index] = isSelected.value[index] ? false : true;

      pumpId.value = data.equipmentID;
      productId.value = data.equipmentID ? 0 : data.pumpDesc.split('-')[0];
      serialNumber.value = data.serialNo;
      isConsignmentStartingPackages.value = true;
      if (isOwnPumps.value === false) {
        mediqPumpOptionSelected.value = true;
        isPumpSelected.value = true;
        showDeliveryDetails.value = true;
      } else {
        mediqPumpOptionSelected.value = false;
        isPumpSelected.value = true;
        showDeliveryDetails.value = false;
      }
      relationProductId.value = pumpId.value == 0 ? productId.value : data.productId;
      isPackageSelected.value = [];
      startingPackages.value = [];
      isNoStartingPackageOptionSelected.value = false;
      let startingPackagesInput = {
        ProductId: relationProductId.value,
        DepotMaterialIds: depotMaterialIds.value?.join(',') ?? '',
        ConsignmentProductFlag: isConsignmentStartingPackages.value
      };
      const response = await getStartingPackagesStore(startingPackagesInput);
      startingPackages.value = Array.isArray(response.data) ? response.data : [];

      if (startingPackages.value.length > 0) {
        const el = startingPackagesRef.value;

        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      } else {
        getAdditionalStartingPackages(!isConsignmentStartingPackages.value);
      }
    };

    const setSerialNumber = (data) => {
      serialNumber.value = data.serialNumber;
    };

    const hasSelectedPackage = computed(
      () => isPackageSelected.value.length > 0 && isPackageSelected.value.some(Boolean)
    );

    const getButtonStatus = () => {
      if (
        mediqPumpOptionSelected.value &&
        isPumpSelected.value &&
        deliveryDetailsValidated.value &&
        hasSelectedPackage.value
      ) {
        return 'btn--cta';
      } else if (isPumpSelected.value && selectedOption.value !== 'mediqpump' && hasSelectedPackage.value) {
        return 'btn--cta';
      } else if (isPackageSelected.value.length > 0 || isNoStartingPackageOptionSelected.value == true) {
        return 'btn--cta';
      } else {
        return 'btn--disabled';
      }
    };

    const cancelPopup = () => {
      showPopup.value = false;
    };

    const getAdditionalPumps = (mediqPumpsFlag) => {
      isSelected.value = [];
      isPackageSelected.value = [];
      startingPackages.value = [];
      mediqPumpOptionSelected.value = false;
      isPumpSelected.value = false;
      selectedDeliveryOption.value = '';
      selectedPackageProductIds.value = [];
      relationProductId.value = 0;
      if (mediqPumpsFlag === false) {
        computeAvailablePumps();
        additionalPumps.value = [];
        manualTelephoneNumber.value = '';
        showManualPump_Warning.value = true;
        showDeliveryDetails.value = false;
        showHomeAddress.value = true;
        showDeliveryAddress.value = false;
        showAddressDetails.value = false;
      } else {
        computedAvailablePumps.value = [];
        serialNumber.value = '';
        showManualPump_Warning.value = false;
        getAdditionalPumpsStore(selectedOption.value).then((response) => {
          additionalPumps.value = response.data;
        });
      }
      isOwnPumps.value = !mediqPumpsFlag;
    };

    const sortAdditionalPumpsByField = (sortFieldDetails) => {
      sortPumpsByField(sortFieldDetails, additionalPumps.value);
    };

    const sortAvailablePumpsByField = (sortFieldDetails) => {
      sortPumpsByField(sortFieldDetails, computedAvailablePumps.value.pumpList);
    };

    const sortPumpsByField = (sortFieldDetails, pumpArray) => {
      let key = sortFieldDetails.option;
      let value = pumpsHeadersForSorting.value[key];
      pumpArray.sort(function (a, b) {
        const leftValue = a[value];
        const rightValue = b[value];
        if (!leftValue) {
          return 1;
        }
        if (!rightValue) {
          return -1;
        }
        if (sortFieldDetails.isAscending) {
          if (typeof leftValue === 'number' && typeof rightValue === 'number') {
            return leftValue < rightValue ? -1 : 1;
          } else {
            return leftValue.localeCompare(rightValue);
          }
        } else {
          if (typeof leftValue === 'number' && typeof rightValue === 'number') {
            return leftValue > rightValue ? -1 : 1;
          } else {
            return rightValue.localeCompare(leftValue);
          }
        }
      });
    };

    const prescriberRredirect = (path) => {
      router.push(path);
    };

    const getAccountabilityFlowStatus = () => {
      return router.currentRoute.value.params.type === 'verantwoording';
    };

    const deliveryOptionSelect = (e) => {
      selectedDeliveryOption.value = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id;
      showDeliveryDate.value = false;
      if (selectedDeliveryOption.value === 'Other') {
        showDeliveryDate.value = true;
      }
    };

    const deliveryLocationSelect = (e) => {
      selectedDeliveryLocation.value = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id;
      showHomeAddress.value = false;
      showDeliveryAddress.value = false;
      showAddressDetails.value = false;
      if (selectedDeliveryLocation.value === 'homeAddress') {
        showHomeAddress.value = true;
      } else if (selectedDeliveryLocation.value === 'deliveryAddress') {
        showDeliveryAddress.value = true;
      } else {
        showAddressDetails.value = true;
      }
    };

    const handleDeliveryDate = (key, date) => {
      deliveryDate.value = date;
    };

    const setRemark = (event) => {
      optionalText.value = event.target ? event.target.value : '';
    };

    const cancelPumpAssignment = () => {
      reConfirmationPopup.value = true;
    };

    const cancelReConfirmationPopup = () => {
      reConfirmationPopup.value = false;
    };

    const getStatusField = (equipmentStatus, warehouseId) => {
      switch (equipmentStatus) {
        case 'Allocated':
          return 'Bij patiënt';
        case 'Available':
          return 'In depot';
        case 'Lend':
          return userWarehouseId.value === warehouseId ? 'In depot, geleend' : 'Uitgeleend';
        case 'LendAndAssigned':
          return userWarehouseId.value === warehouseId ? 'Bij patient, geleend' : 'Uitgeleend en bij patient';
        case '':
          return 'Unknown';
        case 'OutOfDepot':
          return 'Buiten depot';
        default:
          return equipmentStatus;
      }
    };

    const validateAllFields = async () => {
      let result = await validate();
      validationStatus.value = result.valid;
    };

    const searchPump = () => {
      let searchText = document.getElementById('txtSearchPump').value;
      let status = searchText == '' ? '' : 'Available';
      status = isOwnPumps.value === true ? status : 'Mediq';
      let searchDetails = {
        searchText: searchText,
        status: status //'Toon Alles'
      };
      computeAvailablePumps();
      if (
        (!searchDetails.searchText || (searchDetails && searchDetails.searchText.length < 2)) &&
        !searchDetails.status
      ) {
        return;
      }
      if (searchDetails.searchText && searchDetails.searchText.length > 2) {
        const lowerCaseSearchText = searchDetails.searchText.toLowerCase();
        if (isOwnPumps.value === true) {
          computedAvailablePumps.value.pumpList = computedAvailablePumps.value.pumpList.filter((l) => {
            return (
              l.pumpDesc.toLowerCase().includes(lowerCaseSearchText) ||
              (l.serialNo !== null && l.serialNo.toLowerCase().includes(lowerCaseSearchText))
            );
          });
        } else {
          additionalPumps.value = additionalPumps.value.filter((l) => {
            return (
              l.pumpDesc.toLowerCase().includes(lowerCaseSearchText) ||
              (l.serialNo !== null && l.serialNo.toLowerCase().includes(lowerCaseSearchText))
            );
          });
        }
      }
    };

    const savePump = async () => {
      if (mediqPumpOptionSelected.value && (!manualTelephoneNumber.value || !selectedDeliveryOption.value)) {
        if (!selectedDeliveryOption.value) {
          showLeveringError.value = true;
        }
        validate();
        return;
      }
      await validateAllFields();
      if (validationStatus.value == false) {
        return;
      }
      if (isNoStartingPackageOptionSelected.value) {
        selectedPackageProductIds.value = [];
      }
      if (pumpId.value !== 0 && isPumpSelected.value) {
        let requiredDetails = {
          PatientId: patientGegevens.value.PatientId,
          PumpId: pumpId.value,
          LicenseId: licenseId.value,
          PackageDeliveryOption: isConsignmentStartingPackages.value ? 'ForPatient' : 'ForClient',
          PackageProductIds: selectedPackageProductIds.value
        };
        saveAllocatePump(requiredDetails).then(() => {
          showPopup.value = true;
        });
      } else if (isPumpSelected.value && serialNumberValidated.value) {
        let addressType = 0;
        let address = null;
        if (selectedDeliveryLocation.value === 'homeAddress') {
          addressType = 0;
          address = homeAddress.value;
        }
        if (selectedDeliveryLocation.value === 'deliveryAddress') {
          addressType = 1;
          address = deliveryAddress.value;
        }
        if (selectedDeliveryLocation.value === 'differentAddress') {
          addressType = 2;
          address = differentAddress.value;
        }
        let requiredDetails = {
          CustomerId: patientGegevens.value.PatientId,
          ProductId: productId.value,
          SerialNumber: serialNumber.value,
          LicenseId: licenseId.value,
          DeliveryOptions: selectedDeliveryOption.value,
          DeliveryDate: deliveryDate.value,
          AddressType: addressType,
          Address: address,
          Remark: optionalText.value,
          TelephoneNumber: manualTelephoneNumber.value,
          PackageDeliveryOption: isConsignmentStartingPackages.value ? 'ForPatient' : 'ForClient',
          PackageProductIds: selectedPackageProductIds.value
        };
        requiredDetails.DeliveryDate = requiredDetails.DeliveryDate
          ? moment(requiredDetails.DeliveryDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : null;
        allocatePumpFromMediqDepot(requiredDetails).then(() => {
          showPopup.value = true;
        });
      }
    };

    const createAccountability = () => {
      setShowExtendLicensesBlock(false);
      // Call the server for a new accountability, based on data of the current, 'edited' one
      store
        .dispatch('accountability/requestAccountabilityCopy', {
          AccountabilityId: accountabilityId.value,
          IsAccountabilityUsedForAssigningMultiplePumps: true
        })
        .then((response) => {
          const copyAccountabilityId = response.data.Id;
          // Request granted
          navigateToAccountability(copyAccountabilityId);
        })
        .catch((error) => {
          if (error !== 'cancel') {
            const m = error.response.data.Exception.Message;
            new Promise((resolve, reject) => {
              $emitter.emit('prompt', {
                title: 'Machtiging wijzigen',
                message: m,
                confirmButton: 'Naar patiënt dashboard',
                resolve,
                reject
              });
            })
              .then(() => {
                // Start a new accountability with no prefilled data. However, at the end the original still needs to be terminated!!!!!
                // TODO: when template no longer available (exception), then user needs a way to select one before starting anew
                //       the idea right now is that with the exception, backend includes a templateId property in the response in case they can
                //       determine which is the 'follow-up' template when the original is no longer valid
                //       the problem happens when backend cannot and we need to either render a template selection button in the exception overlay
                //       or we need to throw in the towel and tell the user they can't extend an accountability
                // store.dispatch('accountability/startNewAccountability', templateId).then((response) => router.push('/machtiging'))
              })
              .catch(() => {});
          }
        });
    };

    const autoFillAddress = () => {
      fetchAddressLookup({
        postcode: differentAddress.value.Postcode,
        huisnummer: differentAddress.value.Huisnummer,
        land: 'NL'
      })
        .then((response) => {
          var hasAddress = response.data.City !== null;

          differentAddress.value.Straatnaam = hasAddress ? response.data.Street : '';
          differentAddress.value.Woonplaats = hasAddress ? response.data.City : '';
          differentAddress.value.Land = 'NL';
          addressLookup.value = hasAddress ? response.data : null;
          validateAllFields();
          prefillAddressDataKey.value += 1;
        })
        .catch(() => {
          addressLookup.value = null;
          differentAddress.value.Straatnaam = '';
          differentAddress.value.Woonplaats = '';
        });
    };

    const selectProduct = (index, data) => {
      for (var i = 0; i < isPackageSelected.value.length; i++) {
        isPackageSelected.value[i] = false;
      }
      isPackageSelected.value[index] = isPackageSelected.value[index] ? false : true;
      selectedPackageProductIds.value = [];
      selectedPackageProductIds.value.push(data.productCode);
      if (isOwnPumps.value === false) {
        showDeliveryDetails.value = true;
      } else {
        showDeliveryDetails.value = false;
      }
      isNoStartingPackageOptionSelected.value = false;
    };

    watch(selectedDeliveryOption, (value) => {
      if (value) {
        showLeveringError.value = false;
      } else {
        showLeveringError.value = true;
      }
    });

    watch(isNoStartingPackageOptionSelected, (value) => {
      if (value) {
        if (isOwnPumps.value === false) {
          showDeliveryDetails.value = true;
        } else {
          showDeliveryDetails.value = false;
        }
      }
    });

    return {
      patientGegevens,
      user,
      homeAddress,
      differentAddress,
      deliveryAddress,
      saveAllocatePump,
      allocatePumpFromMediqDepot,
      getAdditionalPumpsStore,
      setShowExtendLicensesBlock,
      fetchAddressLookup,
      ...mapActions({
        requestAccountabilityCopy: 'accountability/requestAccountabilityCopy'
      }),
      licenseId,
      accountabilityId,
      licenseOverview,
      customerId,
      patientPumpConfiguration,
      availablePumps,
      userWarehouseId,
      computedAvailablePumps,
      computeAvailablePumps,
      getStartingPackagesStore,
      setNoStartingPackage,
      isNoStartingPackageOptionSelected,
      isPackageSelected,
      depotMaterialIds,
      isConsignmentStartingPackages,
      relationProductId,
      getAdditionalStartingPackages,
      startingPackages,
      selectedDeliveryOption,
      selectedPackageProductIds,
      showDeliveryDetails,
      isOwnPumps,
      isSelected,
      pumpId,
      productId,
      serialNumber,
      mediqPumpOptionSelected,
      isPumpSelected,
      selectPump,
      setSerialNumber,
      selectedOption,
      getButtonStatus,
      hasSelectedPackage,
      deliveryDetailsValidated,
      cancelPopup,
      getAdditionalPumps,
      additionalPumps,
      manualTelephoneNumber,
      showManualPump_Warning,
      showHomeAddress,
      showDeliveryAddress,
      showAddressDetails,
      sortAdditionalPumpsByField,
      sortAvailablePumpsByField,
      sortPumpsByField,
      pumpsHeadersForSorting,
      prescriberRredirect,
      getAccountabilityFlowStatus,
      deliveryOptionSelect,
      showDeliveryDate,
      deliveryLocationSelect,
      deliveryDate,
      handleDeliveryDate,
      setRemark,
      reConfirmationPopup,
      cancelPumpAssignment,
      cancelReConfirmationPopup,
      getStatusField,
      validate,
      validationStatus,
      validateAllFields,
      searchPump,
      serialNumberValidated,
      savePump,
      licenseOverviews,
      addressLookupSuccessful,
      addressLookup,
      showLeveringError,
      createAccountability,
      prefillAddressDataKey,
      autoFillAddress,
      selectProduct,
      showPopup,
      startingPackagesRef,
      allowNoStartingPackageSelection
    };
  }
};
</script>

<style lang="scss" scoped>
.pump-assignment-card {
  color: $teal-darkest;

  :deep(.form-group-simple label) {
    color: $black;
    font-weight: 700;
    font-size: 16px;
  }
}

.pump-assignment {
  .form-group-simple__error {
    .material-design-icon {
      display: inline-flex;
      width: 16px;
      height: 16px;
      fill: #eb0000;
      vertical-align: bottom;
    }
  }

  &__no-pumps {
    background-color: $table-row-background;

    &__cell_data {
      padding: 30px 500px 30px 30px;
    }

    &__cell_thead {
      height: 45px;
      border: 1px solid $gray-light;
      background-color: $teal-lighter;
    }

    &__warning_data {
      padding-top: 30px;
      padding-left: 30px;
      padding-right: 100px;
    }
  }

  &__more-pumps {
    background-color: $table-row-background;
    font-size: 16px;
    color: $black;
    padding: 30px 0 30px 0;
    margin: 24px 0px;

    &__question {
      font-weight: bold;
      padding-left: 25px;
      padding-bottom: 20px;
      text-align: start;
    }

    &__option {
      padding-top: 2px;
      padding-left: 25px;
      padding-bottom: 10px;
    }

    &__button_enable {
      background-color: $orange;
      border: $orange;
    }

    &__button_disable {
      background-color: $gray-light;
      border: $gray-light;
    }

    &__cancel-pumpassignment {
      font-size: 18px;
      color: $teal-darkest;
      padding-right: 20px;
      padding-top: 10px;
    }

    &__table {
      margin-top: 30px;
      margin-bottom: -30px;
    }
  }

  .deliveryDetails {
    margin-bottom: 24px;

    table {
      legend {
        margin: 0 0 20px;
        font-size: 16px;
        font-weight: bold;
      }

      > tr {
        > td,
        > th {
          padding: 10px 20px 16px;
        }
      }

      > tbody {
        > tr {
          > td,
          > th {
            vertical-align: baseline;
            padding: 10px 20px 16px;
            width: 33%;
            max-width: 300px;
          }
        }
      }
    }

    border: 1px solid $gray-light;
    background: $white;

    &__header {
      background-color: $grayish-very-light;
      height: 50px;
    }

    &__header_text {
      font-size: 1.266rem;
      font-weight: 300;
    }

    &__question {
      font-weight: bold;
    }

    &__option {
      color: $gray-dark;
    }
  }
}
</style>
